import { Route } from 'react-router-dom';
import { Routes } from '../Routes';
import { WallGame } from '../../pages/games/wall';

export const WallRouter = () => (
  <Routes>
    <Route path="/*" element={<WallGame />} />
  </Routes>
);
